import { useEffect, useState } from 'react';
import DadosImigracao from './DadosImigracao';
import DadosCadastrais from './DadosCadastrais';
import DadosFuncionais from './DadosFuncionais';
import Documentacao from './Documentacao';
import { Tabs, Spin } from 'antd';
import { matchPath, useHistory, useParams } from 'react-router-dom';
import HistoricoAtendimento from './HistoricoAtendimento';
import Header from "../../../components/Header";
import Footer from '../../../components/Footer';
import Api from '../../../services/api';
import { message, Button } from 'antd';
import { AxiosResponse } from 'axios';
import ServicosOfertados from './ServicosOfertados';
import './styles.css'
import api from '../../../services/api';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import * as PermissaoAction from '../../../redux/actions/permissao';
import { motivoEscolaridadeService } from '../../../services/Motivo-Escolaridade-Service/motivo-escolaridade-service';

interface props {
    dados: any;
    permissao?: any
    setRealizarAtendimento?: any,
}

const Cadastro: React.FC<props> = (props) => {
    let agendamento: any;
    let agendamentos: any[] = [];
    const [agendamentoAtual, setAgendamentoAtual] = useState<any>();

    const [loading, setLoading] = useState(false);
    const { id } = useParams<Record<string, string | undefined>>();
    const { agendamentoID } = useParams<Record<string, string | undefined>>();
    const [dadosCadastraisResponse, setDadosCadastraisResponse] = useState<AxiosResponse<any>>();
    const [documentacaoResponse, setDocumentacaoResponse] = useState<AxiosResponse<any>>();
    const [dadosFuncionaisResponse, setDadosFuncionaisResponse] = useState<AxiosResponse<any>>();
    const [dadosImigracaoResponse, setDadosImigracaoResponse] = useState<AxiosResponse<any>>();
    const [dadosHistoricoResponse, setDadosHistoricoResponse] = useState<any[]>();
    const [arquivosResponse, setArquivosResponse] = useState<AxiosResponse<any>>();
    const [numeroDependentes, setNumeroDependentes] = useState<Number>(0);
    const [numeroDependentesNoBrasil, setNumeroDependentesNoBrasil] = useState<Number>(0);
    const { tab } = useParams<Record<string, string | undefined>>();
    const [escolaridades, setEscolaridades] = useState();
    const [motivoEscolaridade, setMotivoEscolaridade] = useState();

    useEffect(() => {
        getCadastro().then(() => {
            getMotivoEscolaridade();
            getEscolaridade();
            getAgendamento();
            getDependentes();
        }).catch(() => {
            message.error("Falha na requisição");
        })
    }, [])

    const getCadastro = async (): Promise<any> => {
        return new Promise<any>(async (resolve, reject) => {
            setLoading(true);
            let newParams = {
                'id': id ? id : undefined,
                'agendamentoID': agendamentoID ? agendamentoID : undefined,
            }

            await Api.get(`DadosCadastrais/getCadastro`, { params: newParams }).
                then((dados) => {
                    resolve(dados);
                    setDocumentacaoResponse(dados.data?.documentacao ? dados.data?.documentacao : {});
                    setDadosCadastraisResponse(dados.data?.dadosCadastrais ? dados.data?.dadosCadastrais : {});
                    setDadosImigracaoResponse(dados.data?.dadosImigracao ? dados.data?.dadosImigracao : {});
                    setDadosFuncionaisResponse(dados.data?.dadosFuncionais ? dados.data?.dadosFuncionais : {});
                    setArquivosResponse(dados.data?.arquivos ? dados.data?.arquivos : {});
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        });
    }
    const getDependentes = () => {

        Api.get(`DadosCadastrais/getdependentesbyDadosCadastraisID?id=${id}`)
            .then((response: any) => {

                if (response?.data != undefined) {
                    setNumeroDependentes(response?.data.length)
                    setNumeroDependentesNoBrasil((response?.data.filter((d: any) => d.resideNoBrasil === true)).length)
                }
            })
    }

    const getMotivoEscolaridade = () =>{
        setLoading(true)
        Api.get("motivoEscolaridade").then((resp)=>{
            setMotivoEscolaridade(resp.data.filter((i: any) => i.ativo == true))
            setLoading(false);
        })
        .catch(() => {
            message.error("Falha na requisição dos motivos escolaridade");
            setLoading(false);
        })
    }

    const getAgendamento = async () => {
        await Api.get(`Agendamento/getbydadoscadastraisid?id=${id}`).then((response: any) => {
            response.data.forEach((e: any) => {
                let dataHoraIncio: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(e.dataHoraInicio))
                let dataHoraFinal: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(e.dataHoraFinal))
                agendamento = {
                    key: e.agendamentoID,
                    dataHoraInicio: dataHoraIncio,
                    dataHoraFinal: dataHoraFinal,
                    agendamentoID: e.agendamentoID,
                    dadosCadastraisID: e.dadosCadastraisID,
                    duracao: e.duracao,
                    motivo: e.motivo,
                    nome: e.nome,
                    paisOrigem: e.paisOrigem,
                    situacao: e.situacao,
                    servicosOfertados: e.servicosOfertados,
                    instituicaoEncaminhamento: e.instituicaoEncaminhamento,
                    meioComunicacao: e.meioComunicacao
                }

                if (e.agendamentoID == agendamentoID) { setAgendamentoAtual(e) };
                agendamentos.push(agendamento);
            });
            setDadosHistoricoResponse(agendamentos);
        })
    }

    const ehEdicao = window.location.pathname.includes("agendamento");

    const getEscolaridade = () => {
        setLoading(true);
        Api.get('Escolaridade').
            then((response) => {
                setEscolaridades(response.data);
                setLoading(false);
            })
            .catch(() => {
                message.error("Falha na requisição das escolaridades");
                setLoading(false);

            })
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [date, time] = dateTimeString.split(' ');
        // Dividimos a data em dia, mês e ano:
        const [DD, MM, YYYY] = date.split('/');
        // Dividimos o tempo em hora e minutos:
        const [HH, mm] = time.split(':');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}T${HH}:${mm}Z`;
    }
    let history = useHistory();
    const { TabPane } = Tabs;

    function editUrl(e: any) {
        history.push(`${e}`);
    }

    async function pausarAtendimento() {
        await Api.put('Agendamento/pausarAtendimento', {
            AgendamentoID: agendamentoAtual?.agendamentoID,
            DadosCadastrais: agendamentoAtual?.dadosCadastrais,
            DadosCadastraisID: agendamentoAtual?.dadosCadastraisID,
            DataHoraFinal: agendamentoAtual?.dataHoraFinal,
            DataHoraInicio: agendamentoAtual?.dataHoraInicio,
            Motivo: agendamentoAtual?.motivo,
            Nome: agendamentoAtual?.nome,
            PaisOrigem: agendamentoAtual?.paisOrigem,
            ServicosOfertados: agendamentoAtual?.servicosOfertados,
            Situacao: agendamentoAtual?.situacao == "Aberto" ? "Pausado" : agendamentoAtual?.situacao,
            Telefone: agendamentoAtual?.telefone,
            UsuarioAgendamentoID: agendamentoAtual?.usuarioAgendamentoID,
            UsuarioAgendamentoNome: agendamentoAtual?.usuarioAgendamentoNome,
            UsuarioAtendimentoID: agendamentoAtual?.usuarioAtendimentoID,
            UsuarioAtendimentoNome: agendamentoAtual?.usuarioAtendimentoNome,
            InstituicaoEncaminhamentoID: agendamentoAtual?.instituicaoEncaminhamentoID,
            MeioComunicacaoID: agendamentoAtual?.meioComunicacaoID,
        }).then((response) => {
            props.setRealizarAtendimento(false);
            history.push("/home");
            message.success("Pausado com sucesso!");

        }).catch(err => {
            message.error("Não foi possível pausar!");
        });

    }
    const voltarPagina = () => {
        if (history.location.pathname.includes("agendamento")) {
            props.setRealizarAtendimento(false);
            history.push(`/home`)
        }
        else {
            history.push(`/dados-cadastrais/consulta`)
        }
    }


    return (
        <>
            <Header />
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">

                    <Spin spinning={loading}>
                        {/* {ehEdicao ?
                            <div className="button-pausar">
                                <Button disabled={agendamentoAtual?.situacao == "Pausado" ? true : false} style={{ backgroundColor: 'orange' }} onClick={pausarAtendimento}>Pausar</Button>
                            </div> : null
                        } */}

                        <Tabs activeKey={tab} onTabClick={e => editUrl(e)} type="card">
                            <TabPane tab="Dados Cadastrais" key="1">

                                <DadosCadastrais dados={dadosCadastraisResponse} escolaridades={escolaridades} motivoEscolaridade={motivoEscolaridade}
                                    numeroDependentes={numeroDependentes}
                                    numeroDependentesNoBrasil={numeroDependentesNoBrasil}
                                />
                            </TabPane>
                            <TabPane tab="Dados Migração" key="2">
                                <DadosImigracao dados={dadosImigracaoResponse} />
                            </TabPane>
                            <TabPane tab="Documentação" key="3">
                                <Documentacao dados={documentacaoResponse} arquivos={arquivosResponse} />
                            </TabPane>
                            <TabPane tab="Dados Funcionais" key="4">
                                <DadosFuncionais dados={dadosFuncionaisResponse} />
                            </TabPane>
                            {agendamentoID != undefined ?
                                <TabPane disabled={agendamentoID == undefined ? true : false} tab="Serviços Ofertados" key="5">
                                    <ServicosOfertados dados={dadosCadastraisResponse} />
                                </TabPane>
                                : null
                            }
                            <TabPane tab="Histórico de Atendimento" key="6">
                                <HistoricoAtendimento dados={dadosHistoricoResponse} />
                            </TabPane>

                        </Tabs>

                    </Spin>

                </fieldset>
                <Button type="primary" style={{ marginTop: 20 }} onClick={voltarPagina}>  Voltar </Button>

            </div>
            <Footer />
        </>

    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Cadastro);